// Your React component

import React from 'react';
import './PrintStyle.css';
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import TitoLogo from '../assets/images/tito-logo.png';
import KKLogo from '../assets/images/kk-logo.png';
import moment from 'moment';

const PaymentPrint = React.forwardRef((props, ref) => {
    const { bank, vendor, rep, customer, startDate, endDate, data } = props;

    return (
        <div ref={ref} style={{ padding: 50 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={KKLogo} alt="logo" style={{ height: 100, width: 100 }} />
                <h2>KK Foods</h2>
                <img src={TitoLogo} alt="logo" style={{ height: 100, width: 100 }} />
            </div>

            <Grid container>
                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Rep Name:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex' }}>
                        {rep?.map((i, index) => (
                            <Typography>
                                {i?.firstName} {i?.lastName}
                                {index < rep?.length - 1 && `,`}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>

                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Customer Name:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        {customer?.map((i, index) => (
                            <Typography>
                                {i?.name}
                                {index < customer?.length - 1 && ','}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                    <Typography>From Date: {startDate}</Typography>
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                    <Typography>To Date: {endDate}</Typography>
                </Grid>
                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Bank:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex' }}>
                        {bank?.map((i, index) => (
                            <Typography>
                                {i?.name}
                                {index < bank?.length - 1 && `,`}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>

                <Grid item lg={2} md={2} sm={2}>
                    <Typography>Vendor:</Typography>
                </Grid>
                <Grid item lg={10} md={10} sm={10}>
                    <Box sx={{ display: 'flex' }}>
                        {vendor?.map((i, index) => (
                            <Typography>
                                {i?.name}
                                {index < vendor?.length - 1 && `,`}
                                <span>&nbsp;</span>
                            </Typography>
                        ))}
                    </Box>
                </Grid>
            </Grid>

            <TableContainer>
                <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Ref No.</TableCell>
                            <TableCell>Vendor</TableCell>
                            <TableCell>Bank</TableCell>
                            <TableCell>Rep</TableCell>
                            <TableCell>Customer</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Comments</TableCell>
                            <TableCell>Created Date</TableCell>
                            <TableCell>Verified At</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!data &&
                            data?.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }
                                    }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row?.refNo}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row?.vendor?.name}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row?.bank?.name}
                                    </TableCell>
                                    <TableCell>
                                        {row?.user?.firstName} {row?.user?.lastName}
                                    </TableCell>
                                    <TableCell>{row?.customer?.name}</TableCell>
                                    <TableCell>{row?.amount}</TableCell>
                                    <TableCell>{row?.comments}</TableCell>
                                    <TableCell>{moment(row?.createdOn).format('MMM DD, YYYY - hh:mm A')}</TableCell>
                                    <TableCell>{row?.verifiedAt ? moment(row?.verifiedAt).format('MMM DD, YYYY') : '-'}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
});

export default PaymentPrint;
